import { AfterViewInit, Component, OnInit } from '@angular/core';
import { AuthorizationService, OrganizationService, SupersetService, ThemeService, TitleService } from '@ng-cloud/badger-core';
import { embedDashboard } from '@superset-ui/embedded-sdk';
import { Subscription } from 'rxjs';
import { BADGER_DARK_SUPERSET_THEME } from '../../../sass/themes/superset/badger-dark-superset.theme';
import { BADGER_LIGHT_SUPERSET_THEME } from '../../../sass/themes/superset/badger-light-superset.theme';

@Component({
  selector: 'badger-portal-store-dashboard',
  templateUrl: './organization-dna.component.html',
  styleUrl: './organization-dna.component.scss',
  standalone: false
})
export class OrganizationDnaComponent implements OnInit, AfterViewInit {
  storeMaps = [];

  organizationName: string;
  protected loading = true;

  private currentTheme = 'badger-light';
  private embeddedDashboard: any;
  private subscriptions = new Subscription();

  constructor(
    private authorizationService: AuthorizationService,
    private organizationService: OrganizationService,
    private titleService: TitleService,
    private supersetService: SupersetService,
    private themeService: ThemeService

) {
  }

  ngOnInit() {
    this.titleService.setTitle('Organization D&A');

    const orgId = this.authorizationService.getCurrentUserOrgId();

    if (orgId) {
      this.organizationService.getOrganization(orgId).subscribe(organization => {
        this.organizationName = organization.name;
      });
    }

    this.subscriptions.add(
      this.themeService.themes().subscribe(theme => {
        this.currentTheme = theme;
        this.applySupersetTheme();
      })
    );
  }

  private applySupersetTheme(): void {
    if (!this.embeddedDashboard) return;

    const isDark = this.themeService.isDarkTheme(this.currentTheme);
    const selectedTheme = isDark ? BADGER_DARK_SUPERSET_THEME : BADGER_LIGHT_SUPERSET_THEME;

    this.embeddedDashboard.setThemeConfig({
      theme_default: selectedTheme,
      theme_dark: selectedTheme,
    });
  }

  ngAfterViewInit(): void {
    this.supersetService.getEmbedInfo('OrganizationOverview', 'Portal').subscribe(info => {
      embedDashboard({
        id: info.guid,
        supersetDomain: this.supersetService.getSupersetDomain(),
        mountPoint: document.getElementById('dashboard'),
        debug: true,
        fetchGuestToken: () => info.guest_token,
        dashboardUiConfig: { // TODO: dashboard UI config: hideTitle, hideTab, hideChartControls, filters.visible, filters.expanded (optional), urlParams (optional)
          hideTitle: true,
          hideTab: false,
          hideChartControls: false,
          filters: {
            expanded: false
          }
        },
        iframeSandboxExtras: ['allow-same-origin', 'allow-scripts', 'allow-popups-to-escape-sandbox', 'allow-top-navigation', 'allow-modals', 'allow-downloads', 'allow-popups']
      }).then((dashboard) => {
        this.embeddedDashboard = dashboard;
        this.applySupersetTheme();

        const dashboardIFrame = document.querySelector('#dashboard iframe') as HTMLIFrameElement | null;

        if (dashboardIFrame) {
          dashboardIFrame.style.width = '100%';
          dashboardIFrame.style.display = 'block';
          dashboardIFrame.style.border = '0';

          // baseline visible area
          dashboardIFrame.style.minHeight = `calc(100vh - 84px)`;

          dashboardIFrame.style.height = '1600px';
        }

        setTimeout(() => this.loading = false, 500);
      }).catch((error) => {
        console.error('Error embedding dashboard:', error);
        this.loading = false;
      });
    });
  }
}
